import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import SaleOrderDataEntryPopup from "../../salesOrderDataEntry/common/SaleOrderDataEntryPopup";
import MassPickNotesPopup from "../common/MassPickNotesPopup";
import GridOptionsButton from "../../../../../common/GridOptionsButton";
import { Button } from 'devextreme-react/button';
import { ItemOrdersGridOptions } from "../../../../../enum/Enum";

const operationDropDownItems = [
    { id: ItemOrdersGridOptions.MassPickNotesId, name: ItemOrdersGridOptions.MassPickNotesDescription },
];

const tranType = [
    {
        ID: 'C',
        Text: 'Credit - Inventory Effect (In Receiving)',
    },
    {
        ID: 'I',
        Text: 'Order/Invoice - Inventory Effect',
    },
]
const OrderDetailByLotResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "71E5F5D9-F1BB-4A3B-A1E4-B9C046F0FAD0";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
        const [showPopup, setShowPopup] = useState({id:null,visible:false});
        const [selectedDetailRows, setSelectedDetailRows] = useState([]);
        const [massPickNotesVisible, setMassPickNotesVisible] = useState(false);

        const onOperationItemClick = (e) => {
            if (e.itemData?.id === ItemOrdersGridOptions.MassPickNotesId) {
                setMassPickNotesVisible(true);
            }
        };

        /** Legacy opItemOrderBottomMassPickNoteClick clears the grid selection and refreshes once
         *  the dialog closes — whether or not the notes were saved. */
        const closeMassPickNotes = useCallback(() => {
            setMassPickNotesVisible(false);
            const grid = dataGrid.current?.instance();
            if (grid) {
                grid.clearSelection();
                grid.refresh();
            }
        }, []);

        // Selection drives the mass operation only. Legacy kept a focused row independent of the
        // multi-selection, so Edit follows the focused row and stays usable while several rows are
        // ticked for Mass Pick Notes.
        const onSelectionChanged = ({ selectedRowsData }) => {
            setSelectedDetailRows(selectedRowsData || []);
        };

        const onFocusedRowChanged = ({ row }) => {
            setShowPopup({ id: row?.data?.rTransactionHeader ?? null, visible: false });
        };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
              ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
                focusedRowEnabled={true}
                onFocusedRowChanged={onFocusedRowChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="multiple" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNo" caption='Record #' ></Column>
                <Column dataField="customer" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Customer Name' ></Column>
                <Column dataField="type" caption='Type' 
                                    lookup={{ dataSource: tranType, valueExpr: 'ID', displayExpr: 'Text' }} cellRender={cellData => {
                                        switch (cellData.value) {
                                            case 'C':
                                                return <span>Credit - Inventory Effect (In Receiving)</span>;
                                            case 'I':
                                                return <span>Order/Invoice - Inventory Effect</span>;
                                            default:
                                                return <span>{cellData.value}</span>;
                                        }
                                    }}></Column>
                <Column dataField="transactionNumber" caption='Transaction #' ></Column>
                <Column dataField="shipDate" caption='Ship Date' ></Column>
                <Toolbar>
                 <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item location="after">
                        <GridOptionsButton
                            items={operationDropDownItems}
                            onItemClick={onOperationItemClick}
                            disabled={!selectedDetailRows.length}
                        />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <SaleOrderDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
            <MassPickNotesPopup
                visible={massPickNotesVisible}
                onClose={closeMassPickNotes}
                selectedRows={selectedDetailRows}
            />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OrderDetailByLotResult);